import Vue from 'vue'
import App from './App.vue'
import Loader from './Loader.vue'
import Snackbar from './Snackbar.vue'
import { router } from '@/router/router'
import { store } from '@/store/store'
import './foreGroundMessage'
import './assets/styles/main-style.css'
import './assets/styles/media-query.css'
import VueD3 from 'vue-d3'
Vue.use(VueD3)

Vue.component('lco-loader', Loader);
Vue.component('lco-message', Snackbar)
console.log("main js");
Vue.filter('getStringellips', (data) => {
    if(data) {
        return data;
    } 
    return '---'
})

 const vueMain = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vueMain;


// WEBPACK FOOTER //
// ./src/main.js